<ng-container *ngIf="quarter && shop$ | async as shop">
  <div class="shop-container">
    <ng-container>
      <img
        class="shop-img"
        *ngIf="shop.tag === 'General Trade'"
        src="/assets/img/game/shop.svg"
        [ngStyle]="{'width': '24em', 'top': '-1em', 'right': '-1em'}"
      >
      <img
        class="shop-img"
        *ngIf="shop.tag === 'General Trade' && shop.state[quarter] === 'inactive'"
        src="/assets/img/game/inactive-ban.svg"
        [ngStyle]="{'width': '21em', 'top': '7em', 'right': '2em'}"
      >
      <img
        class="shop-img"
        *ngIf="shop.tag === 'Forecourt'"
        src="/assets/img/game/fuel.svg"
        [ngStyle]="{'width': '22em', 'top': '4em', 'right': '2.5em'}"
      >
      <img
        class="shop-img"
        *ngIf="shop.tag === 'Forecourt' && shop.state[quarter] === 'inactive'"
        src="/assets/img/game/inactive-ban.svg"
        [ngStyle]="{'width': '19em', 'top': '7em', 'right': '3em'}"
      >
      <img
        class="shop-img"
        *ngIf="shop.tag === 'Vape Store'"
        src="/assets/img/game/vape-shop.svg"
        [ngStyle]="{'width': '20em', 'top': '-1em', 'right': '4em'}"
      >
      <img
        class="shop-img"
        *ngIf="shop.tag === 'Vape Store' && shop.state[quarter] === 'inactive'"
        src="/assets/img/game/inactive-ban.svg"
        [ngStyle]="{'width': '19em', 'top': '6em', 'right': '5em'}"
      >
    </ng-container>
    <img class="close-icon" (click)="onCloseClick()" src="/assets/img/game/close-round.svg">
    <div class="tags">
      <div 
        class="tag"
        [ngStyle]="{'background-color': shop.state[quarter] === 'inactive' ? '#969696' : shop.type === 'Existing Retailer' ? '#DC0093' : '#12B583'}"
      >{{ shop.type }}</div>
      <div class="tag small"
        [ngStyle]="{'background-color': shop.tag === 'General Trade' ? '#FFB51F' : shop.tag === 'Forecourt' ? '#42C9D8' : '#DB5C1E'}"
      >
        <img *ngIf="shop.tag === 'General Trade'" src="/assets/img/game/general-trade-icon.svg">
        <img *ngIf="shop.tag === 'Forecourt'" src="/assets/img/game/forecourt-icon.svg">
        <img *ngIf="shop.tag === 'Vape Store'" src="/assets/img/game/vape-shop-icon.svg">
        <div>{{ shop.tag }}</div>
      </div>
    </div>
    <div class="card-header">
      <div class="name">{{ shop.name }}</div>
      <div class="boxes">
        <app-box title="Registrations" color="#475160" [radius]="false">
          <div
            class="content"
            [ngStyle]="{color: quarter === 'q2' || shop.state[quarter] === 'inactive' ? 'grey' : getStatColor(shop.kpi[getPrevQuarter(quarter) + '_start'].registrations, shop.registrations)}"
          >{{ shop.state[quarter] === 'inactive' ? 'None' : shop.registrations }}</div>
        </app-box>
        <app-box title="Quality Acquisitions" color="#475160" [radius]="false">
          <div
            class="content"
            [ngStyle]="{color: quarter === 'q2' || shop.state[quarter] === 'inactive' ? 'grey' : getStatColor(shop.kpi[getPrevQuarter(quarter) + '_start'].quality, shop.quality, false)}"
            >{{ shop.state[quarter] === 'inactive' ? 'None' : shop.quality + '%' }}</div>
        </app-box>
        <app-box title="K2L" color="#475160" [radius]="false">
          <div
            class="content"
            [ngStyle]="{color: quarter === 'q2' || shop.state[quarter] === 'inactive' ? 'grey' : getStatColor(shop.kpi[getPrevQuarter(quarter) + '_start'].k2l, shop.k2l)}"
          >{{ shop.state[quarter] === 'inactive' ? 'None' : shop.k2l }}</div>
        </app-box>
      </div>
    </div>
    <div class="card-content">
      <div class="left-column">
        <div class="column highlighted">
          <div class="row">
            <div>CC Volume</div>
            <div class="number"
              [ngStyle]="{color: quarter === 'q2' || shop.state[quarter] === 'inactive' ? 'grey' : getStatColor(shop.stats[getPrevQuarter(quarter)].cc_volume, shop.cc_volume)}"
            >{{ shop.state[quarter] === 'inactive' ? '-' : shop.cc_volume }}</div>
          </div>
          <div class="row">
            <div>Nic Pouch Volume</div>
            <div class="number"
              [ngStyle]="{color: quarter === 'q2' || shop.state[quarter] === 'inactive' ? 'grey' : getStatColor(shop.stats[getPrevQuarter(quarter)].npv, shop.npv)}"
            >{{ shop.state[quarter] === 'inactive' ? '-' : shop.npv }}</div>
          </div>
          <div class="row">
            <div>Vape Spend</div>
            <div class="number"
              [ngStyle]="{color: quarter === 'q2' || shop.state[quarter] === 'inactive' ? 'grey' : getStatColor(shop.stats[getPrevQuarter(quarter)].vape_spend, shop.vape_spend)}"
            >{{ shop.state[quarter] === 'inactive' ? '-' : shop.vape_spend }}</div>
          </div>
          <div class="row">
            <div>Multi-Cat Apetite</div>
            <div class="number"
              [ngStyle]="{color: quarter === 'q2' || shop.state[quarter] === 'inactive' ? 'grey' : getStatColor(shop.stats[getPrevQuarter(quarter)].mca, shop.mca)}"
            >{{ shop.state[quarter] === 'inactive' ? '-' : shop.mca }}</div>
          </div>
          <div class="row">
            <div>DM Skill Level</div>
            <div class="number"
              [ngStyle]="{color: quarter === 'q2' || shop.state[quarter] === 'inactive' ? 'grey' : getStatColor(shop.stats[getPrevQuarter(quarter)].dm_skill, shop.dm_skill)}"
            >{{ shop.state[quarter] === 'inactive' ? '-' : shop.dm_skill }}</div>
          </div>
          <div class="row">
            <div>DM Will Level</div>
            <div class="number"
              [ngStyle]="{color: quarter === 'q2' || shop.state[quarter] === 'inactive' ? 'grey' : getStatColor(shop.stats[getPrevQuarter(quarter)].dm_will, shop.dm_will)}"
            >{{ shop.state[quarter] === 'inactive' ? '-' : shop.dm_will }}</div>
          </div>
          <div class="row">
            <div>Staff Skill Level</div>
            <div class="number"
              [ngStyle]="{color: quarter === 'q2' || shop.state[quarter] === 'inactive' ? 'grey' : getStatColor(shop.stats[getPrevQuarter(quarter)].staff_skill, shop.staff_skill)}"
            >{{ shop.state[quarter] === 'inactive' ? '-' : shop.staff_skill }}</div>
          </div>
          <div class="row">
            <div>Staff Will Level</div>
            <div class="number"
              [ngStyle]="{color: quarter === 'q2' || shop.state[quarter] === 'inactive' ? 'grey' : getStatColor(shop.stats[getPrevQuarter(quarter)].staff_will, shop.staff_will)}"
            >{{ shop.state[quarter] === 'inactive' ? '-' : shop.staff_will }}</div>
          </div>
          <div class="row">
            <div>Footfall Count</div>
            <div class="number"
              [ngStyle]="{color: quarter === 'q2' || shop.state[quarter] === 'inactive' ? 'grey' : getStatColor(shop.stats[getPrevQuarter(quarter)].footfall, shop.footfall)}"
            >{{ shop.state[quarter] === 'inactive' ? '-' : shop.footfall }}</div>
          </div>
        </div>
        <img class="pmi-logo" src="/assets/img/game/pmi-logo.svg">
      </div>
      <div class="right-column">
        <div [ngStyle]="{'background-color': shop.state[quarter] === 'inactive' ? '#969696' : ''}" class="box-header">
          <div>Assign Resources</div>
        </div>
        <div class="box-content">
          <div class="text" *ngIf="shop.state[quarter] === 'active'"><div>Use the toggles below to assign resources. If you run out of a resource, you will have to remove some from another store before assigning it here.</div></div>
          <div class="text" *ngIf="shop.state[quarter] === 'inactive'"><div>This store is Inactive. You cannot assign resources here.</div></div>
          <div class="text" *ngIf="shop.state[quarter] === 'prospect'"><div>Use the toggles below to assign Time to prospect this store. As this is still a New Prospect, you cannot assign other resources here.</div></div>
          <div
            class="triggers"
            *ngIf="quarter && resourcesLeft$ | async as resources"
          >
            <div class="h-box">
              <div
                class="h-box-header purple"
                [ngStyle]="{'background-color': shop.state[quarter] === 'inactive' ? '#969696' : ''}"
              >
                <div class="h-box-header-content">
                  <div class="h-box-title">Time</div>
                  <div class="h-box-subtitle">(hrs per week)</div>
                </div>
              </div>
              <div class="h-box-content">
                <div *ngFor="let x of [1, 2, 3, 4]" class="toggle">
                  <div class="descr">x {{x}}</div>
                  <ng-container *ngIf="shop.state[quarter] !== 'inactive'">
                    <img
                      *ngIf="shop.resources[quarter].time === x"
                      src="/assets/img/game/switch-green.svg"
                      (click)="assignTime(0)"
                    >
                    <img
                      *ngIf="shop.resources[quarter].time !== x && resources.time + shop.resources[quarter].time >= x"
                      src="/assets/img/game/switch-cross.svg"
                      (click)="assignTime(x)"
                    >
                    <img
                      *ngIf="shop.resources[quarter].time !== x && resources.time + shop.resources[quarter].time < x"
                      src="/assets/img/game/switch-blocked.svg"
                    >
                  </ng-container>
                  <img
                    *ngIf="shop.state[quarter] === 'inactive'"
                    src="/assets/img/game/switch-disabled.svg"
                  >
                </div>
              </div>
            </div>
            <div class="h-box" style="width: 80%;">
              <div class="h-box-header green"
                [ngStyle]="{'background-color': shop.state[quarter] === 'inactive' || shop.state[quarter] === 'prospect' ? '#969696' : ''}"
              >
                <div class="h-box-header-content">
                  <div class="h-box-title">TPOSM</div>
                </div>
              </div>
              <div class="h-box-content">
                <div *ngFor="let x of ['p1', 'p4', 'p5', 'full']" class="toggle">
                  <div class="descr">x {{x | titlecase}}</div>
                  <ng-container *ngIf="shop.state[quarter] !== 'inactive' && shop.state[quarter] !== 'prospect'">
                    <img
                      *ngIf="shop.resources[quarter]['tposm_' + x]"
                      src="/assets/img/game/switch-green.svg"
                      (click)="assignTposm('tposm_'+x, 0)"
                    >
                    <img
                      *ngIf="!shop.resources[quarter]['tposm_' + x] && resources['tposm_' + x]"
                      src="/assets/img/game/switch-cross.svg"
                      (click)="assignTposm('tposm_'+x, 1)"
                    >
                    <img
                      *ngIf="!shop.resources[quarter]['tposm_' + x] && !resources['tposm_' + x]"
                      src="/assets/img/game/switch-blocked.svg"
                    >
                  </ng-container>
                  <img
                    *ngIf="shop.state[quarter] === 'inactive' || shop.state[quarter] === 'prospect'"
                    src="/assets/img/game/switch-disabled.svg"
                  >
                </div>
              </div>
            </div>
            <div class="h-box">
              <div class="h-box-header blue"
                [ngStyle]="{'background-color': shop.state[quarter] === 'inactive' || shop.state[quarter] === 'prospect' ? '#969696' : ''}"
              >
                <div class="h-box-header-content">
                  <div class="h-box-title">MCC</div>
                </div>
              </div>
              <div class="h-box-content">
                <div class="toggle">
                  <div class="descr">x 1</div>
                  <ng-container *ngIf="shop.state[quarter] !== 'inactive' && shop.state[quarter] !== 'prospect'">
                    <img
                      *ngIf="shop.resources[quarter].mcc"
                      src="/assets/img/game/switch-green.svg"
                      (click)="assignMcc(0)"
                    >
                    <img
                      *ngIf="!shop.resources[quarter].mcc && resources.mcc"
                      src="/assets/img/game/switch-cross.svg"
                      (click)="assignMcc(1)"
                    >
                    <img
                      *ngIf="!shop.resources[quarter].mcc && !resources.mcc"
                      src="/assets/img/game/switch-blocked.svg"
                    >
                  </ng-container>
                  <img
                    *ngIf="shop.state[quarter] === 'inactive' || shop.state[quarter] === 'prospect'"
                    src="/assets/img/game/switch-disabled.svg"
                  >
                </div>
              </div>
            </div>
            <div class="h-box">
              <div class="h-box-header red"
                [ngStyle]="{'background-color': shop.state[quarter] === 'inactive' || shop.state[quarter] === 'prospect' ? '#969696' : ''}"
              >
                <div class="h-box-header-content">
                  <div class="h-box-title smaller">Incentives</div>
                </div>
              </div>
              <div class="h-box-content">
                <div class="h-block">
                  <div class="controlls">
                    <ng-container *ngIf="shop.state[quarter] !== 'inactive' && shop.state[quarter] !== 'prospect'">
                      <img *ngIf="resources.incentives >= 10"
                        (click)="assignIncentives(shop.resources[quarter].incentives + 10)"
                        src="/assets/img/game/arrow-up.svg"
                      >
                      <img *ngIf="resources.incentives < 10"
                        src="/assets/img/game/arrow-up.svg"
                      >
                      <img *ngIf="shop.resources[quarter].incentives >= 10"
                        (click)="assignIncentives(shop.resources[quarter].incentives - 10)"
                        style="transform: rotate(180deg)"
                        src="/assets/img/game/arrow-up.svg"
                      >
                      <img *ngIf="shop.resources[quarter].incentives < 10"
                        style="transform: rotate(180deg)"
                        src="/assets/img/game/arrow-up.svg"
                      >
                    </ng-container>
                    <ng-container *ngIf="shop.state[quarter] === 'inactive' || shop.state[quarter] === 'prospect'">
                      <img src="/assets/img/game/lock.svg" />
                      <img src="/assets/img/game/lock.svg" />
                    </ng-container>
                  </div>
                  <div class="value">
                    <div>£{{shop.resources[quarter].incentives}}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-container>